/**
 * Root layout: AuthProvider + Outlet. ThemeProvider, CssBaseline and the i18n
 * side-effect import live in main.tsx, ABOVE BootstrapGate, so the bootstrap
 * failure screen is themed too.
 */
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';

export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
